var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldRenderComponent)?_c(_vm.value,_vm._b({tag:"component"},'component',{ index: _vm.index, item: _vm.item, value: _vm.value },false)):_c('span',[_vm._v(_vm._s(_vm.value))])}
var staticRenderFns = []

export { render, staticRenderFns }